module.exports = "/images/mv_bg_01.png?38ab50a04952f643ea2097d65376bb68";